import { GetOnlineAccountResponse } from '@iwoca/lapi-client/edge';

type OnlineAccount = GetOnlineAccountResponse['data'][number];

// A connection with no provider has no TrueLayer account behind it, so
// /open_banking_reconsent/ 404s for it. The dashboard status and the reconsent
// list both gate on this, so they cannot disagree about what is extendable.
export const hasExtendableProvider = (
    account: Pick<OnlineAccount, 'provider'>
) => Boolean(account.provider);
